import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterIdsArraySearchValueObject} from './FilterIdsArraySearchValueObject.js'

export class FilterCommitmentMonthsSearchValueObject extends ValueObject {
  #commitmentMonths

  constructor({commitmentMonths}) {
    super()
    this.#commitmentMonths = commitmentMonths
  }

  static create({commitmentMonths}) {
    return new FilterCommitmentMonthsSearchValueObject({
      commitmentMonths: FilterIdsArraySearchValueObject.create(commitmentMonths)
    })
  }

  static createWithDefaultValue({config, commitmentMonths}) {
    return new FilterCommitmentMonthsSearchValueObject({
      commitmentMonths: FilterIdsArraySearchValueObject.create({
        value: commitmentMonths ?? []
      })
    })
  }

  static createFromUrl({config, commitmentMonths, url = ''}) {
    const {SEMANTIC_KEYWORDS} = config.get('seo')
    const isRenting = url.startsWith('/renting/')

    if (isRenting && url.includes(SEMANTIC_KEYWORDS.RENTING.COMMITMENT_MONTHS)) {
      return new FilterCommitmentMonthsSearchValueObject({
        commitmentMonths: FilterIdsArraySearchValueObject.createForNumbers({
          value: ['12', '24', '36', '48']
        })
      })
    }

    if (isRenting && url.includes(SEMANTIC_KEYWORDS.RENTING.COMMITMENT_MONTHS_NONE)) {
      return new FilterCommitmentMonthsSearchValueObject({
        commitmentMonths: FilterIdsArraySearchValueObject.createForNumbers({
          value: ['0']
        })
      })
    }

    if (isRenting && url.includes(SEMANTIC_KEYWORDS.RENTING.COMMITMENT_MONTHS_12)) {
      return new FilterCommitmentMonthsSearchValueObject({
        commitmentMonths: FilterIdsArraySearchValueObject.createForNumbers({
          value: ['12']
        })
      })
    }

    if (isRenting && url.includes(SEMANTIC_KEYWORDS.RENTING.COMMITMENT_MONTHS_24)) {
      return new FilterCommitmentMonthsSearchValueObject({
        commitmentMonths: FilterIdsArraySearchValueObject.createForNumbers({
          value: ['24']
        })
      })
    }

    if (isRenting && url.includes(SEMANTIC_KEYWORDS.RENTING.COMMITMENT_MONTHS_36)) {
      return new FilterCommitmentMonthsSearchValueObject({
        commitmentMonths: FilterIdsArraySearchValueObject.createForNumbers({
          value: ['36']
        })
      })
    }

    if (isRenting && url.includes(SEMANTIC_KEYWORDS.RENTING.COMMITMENT_MONTHS_48)) {
      return new FilterCommitmentMonthsSearchValueObject({
        commitmentMonths: FilterIdsArraySearchValueObject.createForNumbers({
          value: ['48']
        })
      })
    }

    const urlQueryParms = new URLSearchParams(url.split('?')[1] || '')
    if (urlQueryParms.has('commitmentMonths')) {
      return new FilterCommitmentMonthsSearchValueObject({
        commitmentMonths: FilterIdsArraySearchValueObject.createForNumbers({
          value: urlQueryParms.get('commitmentMonths').split('|')
        })
      })
    }

    return FilterCommitmentMonthsSearchValueObject.createWithDefaultValue({config, commitmentMonths: null})
  }

  static createQueryParams({config, commitmentMonths}) {
    const {DEFAULT_COMMITMENT_MONTHS_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterCommitmentMonthsSearchValueObject({
      commitmentMonths: QueryParamSharedValueObject.createForPipeArray({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT],
        value: commitmentMonths ?? DEFAULT_COMMITMENT_MONTHS_SEARCH
      })
    })
  }

  get isEmpty() {
    return this.#commitmentMonths.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#commitmentMonths.queryParam})
    }
  }

  get value() {
    return this.#commitmentMonths.value
  }

  toJSON() {
    return {
      commitmentMonths: this.#commitmentMonths.toJSON()
    }
  }
}
